import React, { useContext } from "react";
import { useState, useEffect } from "react";
import "../../Tabels/Tabels.css";
import search1 from "../../../Components/assets/icons/search.png";
import Table from "react-bootstrap/Table";
import Header from "../../Header/Header";
import { Context } from "../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import toast, { Toaster } from "react-hot-toast";
import { Button } from "react-bootstrap";
import { IDS } from "../../../utils/common";
import Pagination_Holder from "../../common/Pagination_Holder/Pagination_Holder";
import Pagination from "react-bootstrap/Pagination";
import { useLoader } from "../../../utils/common";
import ExternalOrderSearchInput from "./ExternalOrderSearchInput";
import SupplierSearchInput from "./SupplierSearchInput";
library.add(fas);

// Contacted renders right after ETA, on its own.
const CONTACTED_FIELD = {
  key: "contacted",
  label: "Contacted",
  width: "100px",
};

// These two render right after Goods Received Date.
const TOGGLE_FIELDS_AFTER_GOODS_RECEIVED = [
  {
    key: "material_received",
    label: (
      <>
        Material
        <br />
        Received
      </>
    ),
    width: "100px",
  },
  {
    key: "assembly_in_progress",
    label: (
      <>
        Assembly in
        <br />
        Progress
      </>
    ),
    width: "110px",
  },
];


const TOGGLE_FIELDS_END = [
  {
    key: "ready_for_delivery",
    label: (
      <>
        Ready for
        <br />
        Delivery
      </>
    ),
    width: "100px",
  },
  {
    key: "customer_contacted",
    label: (
      <>
        Customer
        <br />
        Contacted
      </>
    ),
    width: "120px",
  },
];

// Editable numeric columns. GST Amount
const EDITABLE_NUMBER_FIELDS = ["wlp", "gst_percent"];

// Editable plain-text columns
const EDITABLE_TEXT_FIELDS = ["invoice_no", "order_no"];

const formatDateForInput = (value) => {
  if (!value) return "";
  return String(value).slice(0, 10);
};

// GST Amount = WLP * GST% / 100,
const computeGstAmount = (wlp, gstPercent) => {
  const wlpNum = parseFloat(wlp);
  const gstNum = parseFloat(gstPercent);
  if (Number.isNaN(wlpNum) || Number.isNaN(gstNum)) return "";
  return (wlpNum * gstNum) / 100;
};

const ExternalOrder = () => {
  const { getData, postData, Per_Page_Dropdown, isAllow } = useContext(Context);

  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setperPage] = useState(10);
  const [search, setSearch] = useState("");
  const [reset, setReset] = useState();
  const [changeStatus, setChangeStatus] = useState();
  const [totalPages, settotalPages] = useState();
  const [onPageChange, setonPageChange] = useState(1);
  

  // Date range filter
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  const [fieldEdits, setFieldEdits] = useState({});

  const [pendingSupplierNames, setPendingSupplierNames] = useState({});

  const { loading, withLoader } = useLoader();
     const handleSelectSearchSuggestion = (item) => {
    setSearch(item.name);
    setonPageChange(1);
    getDataAll(item.name);
  };
   const getDataAll = async (termOverride) => {
    const searchTerm = termOverride !== undefined ? termOverride : search;
    try {
      const response = await withLoader(() =>
        getData(
          `/admin/orders/external-order?page=${onPageChange}&per_page=${perPage}&term=${searchTerm}&from_date=${fromDate}&to_date=${toDate}`,
        ),
      );
      setData(response);
      setCurrentPage(response?.data?.current_page);
      setperPage(response?.data?.per_page);
      setSearch(response?.data?.search_name);
      settotalPages(response?.data?.total_pages);
    } catch (error) {
      console.error("getDataAll error:", error);
    }
  };

  useEffect(() => {
    getDataAll();
  }, [changeStatus, perPage, reset, onPageChange]);

  const handlePageChange = (pageNumber) => {
    setonPageChange(pageNumber);
  };

  const paginationItems = [];
  for (let page = 1; page <= totalPages; page++) {
    paginationItems.push(
      <Pagination.Item
        key={page}
        active={page === onPageChange}
        onClick={() => handlePageChange(page)}
      >
        {page}
      </Pagination.Item>,
    );
  }

  // ----- Inline editable-field helpers -----

  const handleFieldChange = (id, field, value) => {
    setFieldEdits((prev) => ({ ...prev, [`${id}-${field}`]: value }));
  };

  const getFieldValue = (d, field) => {
    const key = `${d.id}-${field}`;
    return fieldEdits[key] !== undefined ? fieldEdits[key] : (d?.[field] ?? "");
  };

  const clearFieldEdits = (id, fields) => {
    setFieldEdits((prev) => {
      const updated = { ...prev };
      fields.forEach((f) => delete updated[`${id}-${f}`]);
      return updated;
    });
  };

  // (No -> Yes,
  const applyLocalUpdate = (id, updates) => {
    setData((prev) => {
      if (!prev?.data?.data) return prev;
      return {
        ...prev,
        data: {
          ...prev.data,
          data: prev.data.data.map((row) =>
            row.id === id ? { ...row, ...updates } : row,
          ),
        },
      };
    });
  };

  // ----- Toggle handlers -----

  const handleContactedToggle = async (d) => {
    if (d?.contacted) return; // already committed — irreversible
    const supplierId = getFieldValue(d, "supplier_id");
    const orderDate = getFieldValue(d, "order_date");
    const eta = getFieldValue(d, "eta");

    if (!supplierId || !orderDate || !eta) {
      toast.error(
        "Please fill Supplier, Order Date and ETA before marking Contacted.",
      );
      return;
    }

    try {
      const response = await withLoader(() =>
        postData(`/admin/orders/external-order/${d.id}/contacted`, {
          supplier_id: supplierId,
          order_date: orderDate,
          eta,
        }),
      );

      if (!response || response.success === false) {
        toast.error(
          response?.message ||
            "Failed to update Contacted status. Please try again.",
        );
        return;
      }

      setChangeStatus(response);
      applyLocalUpdate(d.id, {
        contacted: true,
        supplier_id: supplierId,
        supplier: pendingSupplierNames[d.id] ?? d?.supplier,
        order_date: orderDate,
        eta,
      });
      clearFieldEdits(d.id, ["supplier_id", "order_date", "eta"]);
      setPendingSupplierNames((prev) => {
        const updated = { ...prev };
        delete updated[d.id];
        return updated;
      });
      getDataAll();
    } catch (error) {
      console.error("Error updating contacted status:", error);
      toast.error("Failed to update Contacted status. Please try again.");
    }
  };

  const handleMaterialReceivedToggle = async (d) => {
    if (d?.material_received) return;
    const wlp = getFieldValue(d, "wlp");
    const gstPercent = getFieldValue(d, "gst_percent");
    const invoiceNo = getFieldValue(d, "invoice_no");
    const orderNo = getFieldValue(d, "order_no");
    const goodsReceivedDate = getFieldValue(d, "goods_received_date");

    if (!wlp || !gstPercent || !invoiceNo || !orderNo || !goodsReceivedDate) {
      toast.error(
        "Please fill WLP, GST%, Invoice No, Order No and Goods Received Date before marking Material Received.",
      );
      return;
    }

    // GST Amount
    const gstAmount = computeGstAmount(wlp, gstPercent);

    try {
      const response = await withLoader(() =>
        postData(`/admin/orders/external-order/${d.id}/material_received`, {
          wlp,
          gst_percent: gstPercent,
          invoice_no: invoiceNo,
          order_no: orderNo,
          goods_received_date: goodsReceivedDate,
        }),
      );

      if (!response || response.success === false) {
        toast.error(
          response?.message ||
            "Failed to update Material Received status. Please try again.",
        );
        return;
      }

      setChangeStatus(response);
      applyLocalUpdate(d.id, {
        material_received: true,
        wlp,
        gst_percent: gstPercent,
        gst_amount: gstAmount,
        invoice_no: invoiceNo,
        order_no: orderNo,
        goods_received_date: goodsReceivedDate,
      });
      clearFieldEdits(d.id, [
        "wlp",
        "gst_percent",
        "invoice_no",
        "order_no",
        "goods_received_date",
      ]);
      getDataAll();
    } catch (error) {
      console.error("Error updating material received status:", error);
      toast.error(
        "Failed to update Material Received status. Please try again.",
      );
    }
  };

  const handleAssemblyInProgressToggle = async (d) => {
    if (d?.assembly_in_progress) return;
    const deliveredDate = getFieldValue(d, "delivered_date");

    if (!deliveredDate) {
      toast.error(
        "Please fill Delivered Date before marking Assembly in Progress.",
      );
      return;
    }

    try {
      const response = await withLoader(() =>
        postData(`/admin/orders/external-order/${d.id}/assembly_in_progress`, {
          delivered_date: deliveredDate,
        }),
      );

      if (!response || response.success === false) {
        toast.error(
          response?.message ||
            "Failed to update Assembly in Progress status. Please try again.",
        );
        return;
      }

      setChangeStatus(response);
      applyLocalUpdate(d.id, {
        assembly_in_progress: true,
        delivered_date: deliveredDate,
      });
      clearFieldEdits(d.id, ["delivered_date"]);
      getDataAll();
    } catch (error) {
      console.error("Error updating assembly in progress status:", error);
      toast.error(
        "Failed to update Assembly in Progress status. Please try again.",
      );
    }
  };

  const handleReadyForDeliveryToggle = async (d) => {
    if (d?.ready_for_delivery) return;
    try {
      const response = await withLoader(() =>
        postData(`/admin/orders/external-order/${d.id}/ready_for_delivery`, {}),
      );

      if (!response || response.success === false) {
        toast.error(
          response?.message ||
            "Failed to update Ready for Delivery status. Please try again.",
        );
        return;
      }

      setChangeStatus(response);
      applyLocalUpdate(d.id, { ready_for_delivery: true });
      getDataAll();
    } catch (error) {
      console.error("Error updating ready for delivery status:", error);
      toast.error(
        "Failed to update Ready for Delivery status. Please try again.",
      );
    }
  };


  const handleCustomerContactedToggle = async (d) => {
    if (d?.customer_contacted) return;
    try {
      const response = await withLoader(() =>
        postData(`/admin/orders/external-order/${d.id}/customer_contacted`, {}),
      );

      if (!response || response.success === false) {
        toast.error(
          response?.message ||
            "Failed to update Customer Contacted status. Please try again.",
        );
        return;
      }

      setChangeStatus(response);
      applyLocalUpdate(d.id, { customer_contacted: true });
      getDataAll();
    } catch (error) {
      console.error("Error updating customer contacted status:", error);
      toast.error(
        "Failed to update Customer Contacted status. Please try again.",
      );
    }
  };

  const TOGGLE_HANDLERS = {
    contacted: handleContactedToggle,
    material_received: handleMaterialReceivedToggle,
    assembly_in_progress: handleAssemblyInProgressToggle,
    ready_for_delivery: handleReadyForDeliveryToggle,
    customer_contacted: handleCustomerContactedToggle,
  };

  //  toggle's

  const TOGGLE_REQUIREMENTS = {
    contacted: {
      fields: ["supplier_id", "order_date", "eta"],
      message: "Fill Supplier, Order Date and ETA to enable",
    },
    material_received: {
      fields: [
        "wlp",
        "gst_percent",
        "invoice_no",
        "order_no",
        "goods_received_date",
      ],
      message:
        "Fill WLP, GST%, Invoice No, Order No and Goods Received Date to enable",
    },
    assembly_in_progress: {
      fields: ["delivered_date"],
      message: "Fill Delivered Date to enable",
    },
    ready_for_delivery: {
      fields: [],
      message: "",
    },
    customer_contacted: {
      fields: [],
      message: "",
    },
  };

  const isToggleReady = (d, key) => {
    const requirement = TOGGLE_REQUIREMENTS[key];
    if (!requirement) return true;
    return requirement.fields.every((field) => {
      const value = getFieldValue(d, field);
      return value !== undefined && value !== null && value !== "";
    });
  };


  // Assembly in Progress, Ready for Delivery, Customer Contacted).
  const renderToggleCell = (field, d) => {
    const isOn = !!d?.[field.key];
    const ready = isToggleReady(d, field.key);
    const handler = TOGGLE_HANDLERS[field.key];

    // Add tooltip text specifically for the Customer Contacted column
    const tdTitle =
      field.key === "customer_contacted" &&
      (d?.customer_name || d?.customer_contact_no)
        ? `Name: ${d?.customer_name || "N/A"}\nContact: ${d?.customer_contact_no || "N/A"}`
        : undefined;

    return (
      <td key={field.key}>
        <div
          className="form-check form-switch"
          title={
            !isOn && !ready
              ? TOGGLE_REQUIREMENTS[field.key]?.message
              : undefined
          }
        >
          <input
            className="form-check-input"
            type="checkbox"
            role="switch"
            checked={isOn}
            disabled={!isAllow?.includes(51) || isOn || !ready}
            onChange={() => handler(d)}
            id={`${field.key}${d?.id}`}
          />
          <label className="form-check-label" htmlFor={`${field.key}${d?.id}`}>
            {isOn ? "Yes" : "No"}
          </label>
        </div>
      </td>
    );
  };
  // ---------------------------------------------------------------------

  const handleReset = () => {
    setSearch("");
    setFromDate("");
    setToDate("");
    setFieldEdits({});
    setPendingSupplierNames({});
    setReset(!reset);
  };

  //  column hide and show.....
  const [visible, setVisibel] = useState({
    sr_no: true,
    sales_invoice_no: true,
    product_details: true,
    supplier: true,
    order_date: true,
    eta: true,
    contacted: true,
    wlp: true,
    gst_percent: true,
    gst_amount: true,
    invoice_no: true,
    order_no: true,
    goods_received_date: true,
    material_received: true,
    assembly_in_progress: true,
    delivered_date: true,
    ready_for_delivery: true,
    customer_contacted: true,

    customer_name: false,
    customer_contact_no: false,
  });

  const [user, setUser] = useState({});
  const GetUser = async () => {
    const response = await getData(`/common/auth/usersingleget`);
    if (response?.success) {
      setUser(response?.data);
    }
  };
  useEffect(() => {
    GetUser();
  }, []);

  return (
    <>
      <div className="main-advancedashboard">
        <Header
          title={"External Order"}
          link={"/admin/orders/external-order"}
        />
        <section className="AdvanceDashboard">
          <div className="col-lg-12 p-0">
            <div className="row MainRowsec me-0 ms-0">
              <section className="Tabels tab-radio tab-radio">
                <div className="">
                  {/* container */}
                  <div className="row">
                    <div className="border-line mt-3"></div>
                    <div className="row mt-3">
                      <div className="col-12">
                        <div className="row align-items-start">
                          {/* Date range filter */}
                          <div className="col-xxl-2 col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12 mb-2">
                            <label className="form-label">From Date</label>
                            <input
                              type="date"
                              className="form-control"
                              value={fromDate}
                              onChange={(e) => setFromDate(e.target.value)}
                            />
                          </div>
                          <div className="col-xxl-2 col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12 mb-2">
                            <label className="form-label">To Date</label>
                            <input
                              type="date"
                              className="form-control"
                              value={toDate}
                              onChange={(e) => setToDate(e.target.value)}
                            />
                          </div>

                          {/* Search name */}
                                                    {/* Search name */}
                          <div className="col-xxl-3 col-xl-4 col-lg-4 col-md-6  col-sm-6 col-12 mb-2">
                            <label className="form-label"></label>
                            <div className="num">
                              <ExternalOrderSearchInput
                                value={search}
                                onChange={setSearch}
                                onSelect={handleSelectSearchSuggestion}
                              />
                            </div>
                          </div>
                          <div className="col-xxl-1 col-xl-2  col-lg-2  col-md-2  col-sm-6 col-12 mb-2">
                            <label className="form-label"></label>
                            <div className="Search">
                              <Button
                                type="button"
                                onClick={() => {
                                  setonPageChange(1);
                                  getDataAll();
                                }}
                                className="btn btn-search"
                              >
                                <img src={search1} className="search" alt="" />
                              </Button>
                            </div>
                          </div>
                          <div className="col-xxl-1 col-xl-2  col-lg-2  col-md-2  col-sm-6 col-12 mb-2">
                            <label className="form-label"></label>
                            <div className="Search-1">
                              <button
                                type="button"
                                onClick={handleReset}
                                className="btn btn-reset"
                              >
                                Reset
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="border-line mt-3"></div>
                  <div className="row mt-3">
                    <div className="data table-responsive">
                      <Table
                        striped
                        bordered
                        hover
                        responsive
                        center
                        style={{ tableLayout: "fixed" }}
                      >
                        <thead>
                          <tr className="">
                            {visible.sr_no && (
                              <th className="sr" style={{ width: "70px" }}>
                                Sr. No.
                              </th>
                            )}
                            {visible.sales_invoice_no && (
                              <th style={{ width: "120px" }}>
                                Sales Invoice No.
                              </th>
                            )}
                            {visible.product_details && (
                              <th style={{ width: "320px" }}>
                                Product Details
                              </th>
                            )}
                            {visible.supplier && (
                              <th style={{ width: "180px" }}>Supplier</th>
                            )}
                            {visible.order_date && (
                              <th style={{ width: "140px" }}>Order Date</th>
                            )}
                            {visible.eta && (
                              <th style={{ width: "140px" }}>ETA</th>
                            )}
                            {visible.contacted && (
                              <th style={{ width: CONTACTED_FIELD.width }}>
                                {CONTACTED_FIELD.label}
                              </th>
                            )}
                            {visible.wlp && (
                              <th style={{ width: "90px" }}>WLP</th>
                            )}
                            {visible.gst_percent && (
                              <th style={{ width: "90px" }}>GST%</th>
                            )}
                            {visible.gst_amount && (
                              <th style={{ width: "100px" }}>
                                GST
                                <br />
                                Amount
                              </th>
                            )}
                            {visible.invoice_no && (
                              <th style={{ width: "180px" }}>Invoice No</th>
                            )}
                            {visible.order_no && (
                              <th style={{ width: "120px" }}>Order No</th>
                            )}
                            {visible.goods_received_date && (
                              <th style={{ width: "160px" }}>
                                Goods Received Date
                              </th>
                            )}
                            {TOGGLE_FIELDS_AFTER_GOODS_RECEIVED.map(
                              (field) =>
                                visible[field.key] && (
                                  <th
                                    key={field.key}
                                    style={{ width: field.width }}
                                  >
                                    {field.label}
                                  </th>
                                ),
                            )}
                            {visible.delivered_date && (
                              <th style={{ width: "140px" }}>Delivered Date</th>
                            )}
                            {TOGGLE_FIELDS_END.map(
                              (field) =>
                                visible[field.key] && (
                                  <th
                                    key={field.key}
                                    style={{ width: field.width }}
                                  >
                                    {field.label}
                                  </th>
                                ),
                            )}

                            {visible.customer_name && (
                              <th style={{ width: "140px" }}>Customer Name</th>
                            )}

                            {visible.customer_contact_no && (
                              <th style={{ width: "140px" }}>
                                Customer Contact No
                              </th>
                            )}
                          </tr>
                        </thead>
                        <tbody>
                          {data?.data?.data?.map((d, index) => {
                            const paginatedIndex =
                              (onPageChange - 1) * perPage + index + 1;
                            const liveGstAmount = computeGstAmount(
                              getFieldValue(d, "wlp"),
                              getFieldValue(d, "gst_percent"),
                            );
                            return (
                              <tr className="" key={index}>
                                {visible.sr_no && <td>{paginatedIndex}.</td>}

                                {visible.sales_invoice_no && (
                                  <td
                                    title={
                                      d?.customer_name || d?.customer_contact_no
                                        ? `Name: ${d?.customer_name || "N/A"}\nContact: ${d?.customer_contact_no || "N/A"}`
                                        : undefined
                                    }
                                  >
                                    {d?.sales_invoice_no}
                                  </td>
                                )}

                                {visible.product_details && (
                                  <td className="width_dertails_name_div">
                                    {d?.product_details}
                                  </td>
                                )}

                                {/* Supplier  */}
                                {visible.supplier && (
                                  <td>
                                    <SupplierSearchInput
                                      currentName={
                                        pendingSupplierNames[d.id] ??
                                        d?.supplier
                                      }
                                      disabled={!!d?.contacted}
                                      onSelect={(supplier) => {
                                        if (d?.contacted) return;
                                        handleFieldChange(
                                          d.id,
                                          "supplier_id",
                                          supplier.id,
                                        );
                                        setPendingSupplierNames((prev) => ({
                                          ...prev,
                                          [d.id]: supplier.name,
                                        }));
                                      }}
                                    />
                                  </td>
                                )}

                                {/* Order Date, ETA */}
                                {["order_date", "eta"].map(
                                  (field) =>
                                    visible[field] && (
                                      <td key={field}>
                                        <input
                                          type="date"
                                          className="form-control form-control-sm"
                                          style={{ width: "100%" }}
                                          value={formatDateForInput(
                                            getFieldValue(d, field),
                                          )}
                                          disabled={!!d?.contacted}
                                          onChange={(e) =>
                                            handleFieldChange(
                                              d.id,
                                              field,
                                              e.target.value,
                                            )
                                          }
                                        />
                                      </td>
                                    ),
                                )}

                                {/* Contacted */}
                                {visible.contacted &&
                                  renderToggleCell(CONTACTED_FIELD, d)}

                                {/* WLP, GST% */}
                                {EDITABLE_NUMBER_FIELDS.map(
                                  (field) =>
                                    visible[field] && (
                                      <td key={field}>
                                        <input
                                          type="number"
                                          className="form-control form-control-sm"
                                          style={{ width: "100%" }}
                                          value={getFieldValue(d, field)}
                                          min={0}
                                          max={
                                            field === "gst_percent"
                                              ? 100
                                              : undefined
                                          }
                                          disabled={!!d?.material_received}
                                          onChange={(e) => {
                                            let val = e.target.value;
                                            if (
                                              field === "gst_percent" &&
                                              val !== "" &&
                                              Number(val) > 100
                                            ) {
                                              val = "100";
                                            }
                                            handleFieldChange(d.id, field, val);
                                          }}
                                        />
                                      </td>
                                    ),
                                )}

                                {/* GST Amount — auto-calculated (WLP * GST% / 100), */}
                                {visible.gst_amount && (
                                  <td>
                                    {liveGstAmount !== ""
                                      ? Number(liveGstAmount).toFixed(2)
                                      : d?.gst_amount != null
                                        ? Number(d.gst_amount).toFixed(2)
                                        : "-"}
                                  </td>
                                )}

                                {/* Invoice No, Order No */}
                                {/* Invoice No, Order No */}
                                {EDITABLE_TEXT_FIELDS.map(
                                  (field) =>
                                    visible[field] && (
                                      <td
                                        key={field}
                                        title={
                                          field === "invoice_no" &&
                                          (d?.customer_name ||
                                            d?.customer_contact_no)
                                            ? `Name: ${d?.customer_name || "N/A"}\nContact: ${d?.customer_contact_no || "N/A"}`
                                            : undefined
                                        }
                                      >
                                        <input
                                          type="text"
                                          className="form-control form-control-sm"
                                          style={{ width: "100%" }}
                                          value={getFieldValue(d, field)}
                                          disabled={!!d?.material_received}
                                          onChange={(e) =>
                                            handleFieldChange(
                                              d.id,
                                              field,
                                              e.target.value,
                                            )
                                          }
                                        />
                                      </td>
                                    ),
                                )}

                                {/* Goods Received Date */}
                                {visible.goods_received_date && (
                                  <td>
                                    <input
                                      type="date"
                                      className="form-control form-control-sm"
                                      style={{ width: "100%" }}
                                      value={formatDateForInput(
                                        getFieldValue(d, "goods_received_date"),
                                      )}
                                      disabled={!!d?.material_received}
                                      onChange={(e) =>
                                        handleFieldChange(
                                          d.id,
                                          "goods_received_date",
                                          e.target.value,
                                        )
                                      }
                                    />
                                  </td>
                                )}

                                {/* Material Received, Assembly in Progress */}
                                {TOGGLE_FIELDS_AFTER_GOODS_RECEIVED.map(
                                  (field) =>
                                    visible[field.key] &&
                                    renderToggleCell(field, d),
                                )}

                                {/* Delivered Date */}
                                {visible.delivered_date && (
                                  <td>
                                    <input
                                      type="date"
                                      className="form-control form-control-sm"
                                      style={{ width: "100%" }}
                                      value={formatDateForInput(
                                        getFieldValue(d, "delivered_date"),
                                      )}
                                      disabled={!!d?.assembly_in_progress}
                                      onChange={(e) =>
                                        handleFieldChange(
                                          d.id,
                                          "delivered_date",
                                          e.target.value,
                                        )
                                      }
                                    />
                                  </td>
                                )}

                                {/* Ready for Delivery, Customer Contacted */}
                                {TOGGLE_FIELDS_END.map(
                                  (field) =>
                                    visible[field.key] &&
                                    renderToggleCell(field, d),
                                )}

                                {/* customer_name */}
                                {visible.customer_name && (
                                  <td>{d?.customer_name}</td>
                                )}

                                {/* customer_contact_no */}
                                {visible.customer_contact_no && (
                                  <td>{d?.customer_contact_no}</td>
                                )}
                              </tr>
                            );
                          })}
                        </tbody>
                      </Table>
                      {data && data?.data?.data?.length > 0 ? (
                        <Pagination_Holder
                          onPageChange={currentPage}
                          totalPages={totalPages}
                          handlePageChange={handlePageChange}
                        />
                      ) : (
                        <p className="no-datashow">Sorry, No Data Found</p>
                      )}
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </section>
      </div>

      <Toaster position="top-right" />
    </>
  );
};

export default ExternalOrder;
